import { localStorage } from "@prismicio/editor-support/DOM"
import { request } from "@prismicio/editor-support/Http"
import { z } from "zod"

import { env } from "../app/env"

const Session = z.object({
  id: z.string(),
  defaultDocumentId: z.string(),
})
type Session = z.infer<typeof Session>

export const SESSION_HEADER_NAME = "x-prismic-demo-session"
const LOCAL_STORAGE_SESSION_ID_KEY = "$$-demo-session-id"

const globalSession = createSession()

export async function getSession() {
  return await globalSession
}

export function removeSession() {
  localStorage.remove(LOCAL_STORAGE_SESSION_ID_KEY)
}

// The `/session` endpoint is not proxied.
// The session header should be set manually.
async function createSession() {
  const headers = new Headers()

  const existingSessionId = localStorage.read(LOCAL_STORAGE_SESSION_ID_KEY)
  if (existingSessionId) headers.set(SESSION_HEADER_NAME, existingSessionId)

  const session = await request(
    new URL("session", env.PRISMIC_DEMO_API_BASE_URL),
    {
      method: "PUT",
      headers,
      okType: Session,
    },
  )

  localStorage.write(LOCAL_STORAGE_SESSION_ID_KEY, session.id)

  // Session set up can happen in the background.
  void request(new URL("session-set-up", env.PRISMIC_DEMO_API_BASE_URL), {
    method: "POST",
    headers: { [SESSION_HEADER_NAME]: session.id },
    okType: z.object({ success: z.boolean() }),
  })

  return session
}
